import { render, staticRenderFns } from "./Erp6SaleBaseSalespersonEdit.vue?vue&type=template&id=f490d296&scoped=true&"
import script from "./Erp6SaleBaseSalespersonEdit.vue?vue&type=script&lang=js&"
export * from "./Erp6SaleBaseSalespersonEdit.vue?vue&type=script&lang=js&"
import style0 from "./Erp6SaleBaseSalespersonEdit.vue?vue&type=style&index=0&id=f490d296&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f490d296",
  null
  
)

export default component.exports